import React from 'react';
import Section from './project-section';
import hand from '../media/engs/hand.png';
import mouth from '../media/engs/mouth-stick.png';
import chorder from '../media/engs/chorder.gif';
import basic from '../media/engs/basic.png';
import jason from '../media/engs/jason.jpeg';
import mine from '../media/engs/mine.png';
import functional from '../media/engs/functional.gif';
import layout from '../media/engs/layout.png';
import lego from '../media/engs/lego.png';
import wiring from '../media/engs/wiring.png';

const stateOfArt = [
  { src: mouth, alt: 'a mouth stick keyboard' },
  { src: chorder, alt: 'a directional keyboard' },
];

const initial = [
  { src: basic, alt: 'initial prototype', caption: 'Basic concept' },
  { src: jason, alt: 'jason\'s prototype' },
  { src: mine, alt: 'my prototype' },
];

const functionalFigures = [
  { src: layout, alt: 'layout chart' },
  { src: functional, alt: 'functional prototype' },
  { src: wiring, alt: 'wiring diagram for the prototype' },
];

const ENGS21 = () => {
  return (
    <>
      <Section>
        <p>
          For the course Introduction to Engineering (ENGS 21), I brainstormed, designed,
          and prototyped a product with a team of other students around the theme of Veteran&apos;s Experiences
        </p>
      </Section>

      <Section title="Project Background" figures={[{ src: hand, alt: 'hand with missing fingers' }]}>
        <p>
          For our project, we targeted meeting the needs of disabled veterans to keep up with an increasingly digitized workforce.
          Over 65% of jobs require typing skills, while disabled veterans who are missing hands or fingers may be unable to adapt to fast-paced computer usage required for modern jobs.
          Our team designed a keyboard-like input device, which allow an estimated 30,000 veterans with missing
          hands and fingers to type with speeds at or above those using QWERTY keyboards with ten fingers.
        </p>
      </Section>

      <Section title="State of the Art Technology" figures={stateOfArt}>
        <p>
          For our project, we needed a keyboard that is accessible, and significantly improves typing speed.
          For this, we investigated technologies that focus on accessibility, such as one-handed keyboards, mouth-stick keyboards, and speech-to-text systems.
          These accessible options were highly usable, but too slow to keep up with required typing speeds of computer-heavy work.
        </p>
        <p>
          We also investigated two important technologies for increasing typing speeds: directional keys (where eack key can be pushed in a different direction for different inputs)
          and key chording(when two key presses are combined to form a new, distinct input).
          These technologies greatly improved typing speed, are impossible to use for users missing fingers.
        </p>
      </Section>

      <Section title="Initial Prototyping" figures={initial}>
        <p>We decided to combine the technologies of directional keys and chording for our input device, where pushing one or more joysticks in specific directions inputs a letter.</p>
        <p>From initial ideas, we produced several prototypes, centered on two main specifications: typing speed and configurability.</p>
      </Section>

      <Section title="First Functional Prototype" figures={functionalFigures}>
        <p>
          Our first functional prototype worked fully, with the user entering letters based on chorded directional inputs.
          Using the layout chart, the system translated joystick directions into letters.
          The main issue was that the system was still not configurable, so only users with specific fingers could use it.
        </p>
      </Section>

      <Section title="Further Prototyping" figures={[{ src: lego, alt: 'lego prototype' }]}>
        <p>After testing the functional prototype for comfort and typing speed on volunteers, we confronted two main problems.</p>
        <ol>
          <li>The layout was too confusing to read, leading to slower learning and typing</li>
          <li>The keys were uncomfortable to reach and use for different sized hands</li>
        </ol>
        <p>
          For the first issue, we re-created the layout to be easer to learn, so memorization would lead to faster typing speeds.
          We also implemented a memorization game to assist users in learning how to type.
        </p>
        <p>
          For the second issue, we constructed our next prototype out of LEGOs.
          This allows use to pick up, place, and adjust any finger joystick to fit the specific users.
          This allows for far greater configurability between users.
        </p>
      </Section>
    </>
  );
};

export default ENGS21;
